(function ($) {
  $(document).ready(function () {
    var $loadMoreButton = $("#loadMore");
    if (!$loadMoreButton.length) {
       return;
    }

    var loadType = $loadMoreButton.data("load-type") || "exhibitions"; // Default to exhibitions if not specified
    var maxPages = $loadMoreButton.data("max-pages");
    var currentPage = 2;
    var canBeLoaded = true;
    var bottomOffset = 3000;

    // Determine where to append the posts based on load type
    var $postList;
    if (loadType === "events") {
      $postList = $(".event-list.m-archive");
    } else {
      // For exhibitions, videos, or any other type
      $postList = $(".event-list.m-archive .events-list");
    }

    $(window).scroll(function () {
      if (
        $(document).scrollTop() > $(document).height() - bottomOffset &&
        canBeLoaded === true
      ) {
        $.ajax({
          type: "post",
          dataType: "html",
          url: loadMorePosts.ajax_url,
          data: {
            page: currentPage,
            action: "ajax_load_more_" + loadType,
          },
          beforeSend: function () {
            canBeLoaded = false;
          },
          success: function (response) {
            var $content = $(response);
            $postList.append($content);

            if (currentPage === maxPages) {
              $("#loadMore").fadeOut(300);
            } else {
              canBeLoaded = true;
              currentPage++;
            }
          },
          error: function (MLHttpRequest, textStatus, errorThrown) {
            $("#loadMore").append(
              "<h2>" + MLHttpRequest + textStatus + errorThrown + "</h2>"
            );
          },
        });
      }
    });
  });
})(jQuery);
